module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am204-937cbf13a5264494e69c48d19c8eba14.jpg";